import React from 'react';

import Typography from 'components/Typography';
import { NumberValueFormatter } from 'intl';

import { IDescriptionPercent } from './interfaces';

export const DescriptionPercent: React.FC<IDescriptionPercent> = ({
  value,
  maximumFractionDigits,
  ...other
}) => {
  return (
    <Typography {...other}>
      <NumberValueFormatter.Percent
        value={value}
        maximumFractionDigits={maximumFractionDigits}
      />
    </Typography>
  );
};
